import { render, staticRenderFns } from "./DownloadTab.vue?vue&type=template&id=9d7a06b0&scoped=true&"
import script from "./DownloadTab.vue?vue&type=script&lang=js&"
export * from "./DownloadTab.vue?vue&type=script&lang=js&"
import style0 from "./DownloadTab.vue?vue&type=style&index=0&id=9d7a06b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7a06b0",
  null
  
)

export default component.exports